module.exports = {
    'en' : {
    }
}